// Our Components
import PageHeading from 'components/PageHeading/PageHeading';
import PylonLoanApplication from 'components/Pylon/PylonLoanApplication';

function PylonLoanApplicationPage() {
	return (
		<>
			<PageHeading
				title="Pylon Loan Application"
				subtitleText="Please select an advisor and one of their clients to start a loan application."
			/>

			<PylonLoanApplication />
		</>
	);
}

export default PylonLoanApplicationPage;
